import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
import axios from 'axios';
import './VideoRoomComponent.css';
import "./agora_meeting.css";



import AgoraVideoCall from "../layout/AgoraCanvas";

// import Mic from '@material-ui/icons/Mic';
// import MicOff from '@material-ui/icons/MicOff';

//import { OpenVidu } from 'openvidu-browser';
import AgoraRTC from "agora-rtc-sdk-ng";

//import StreamComponent from './stream/StreamComponent';
//import DialogExtensionComponent from './dialog-extension/DialogExtension';
//import ChatComponent from './chat/ChatComponent';

//import OpenViduLayout from '../layout/openvidu-layout';
//import UserModel from '../models/user-model';
//import ToolbarComponent from './toolbar/ToolbarComponent';

import ConfirmLeaveChatModal from 'components/Modals/ConfirmLeaveChatModal';
import ChangeChatHostModal from 'components/Modals/ChangeChatHostModal';

import { Alert, Button } from 'react-bootstrap';

import {  apiUrl} from "Api/Api";
// , searchUrl, org_friendly_url, user_entity_uuid, user_API, user_Status, user_Status_Ver, presentation_Creation_API, myHeaders_Auth_With_Cache_Control, myHeaders_With_Cache_Control owner_perms, org_name, user_access_level, organization_user_access_level, user_account_level,
import { assembleNickname } from 'utils/Helper';

import logo from 'Assets/PK_Logo_LOCK_Horiz_ColorWhite.png';

import TextChat from 'components/TextChat/TextChat';


//var localUser = new UserModel();

const rtc = {
  // For the local client
  client: null,
  // For the local audio and video tracks
  localAudioTrack: null,
  localVideoTrack: null,
  shareScreenTrack: null
  //remoteAudioTrack: null,
  //remoteVideoTrack: null
};

const rtc_shareScreen = {
  client: null,
  localVideoTrack: null
}

class VideoRoomComponent extends Component {
    constructor(props) {
        super(props);
        this.AGORA_APP_ID = '0c801d6b0d55406582213b48e5468038';
        //this.OPENVIDU_SERVER_URL = this.props.openviduServerUrl
        //    ? this.props.openviduServerUrl
        //    : 'https://' + window.location.hostname + ':4443';
        //this.OPENVIDU_SERVER_SECRET = this.props.openviduSecret ? this.props.openviduSecret : 'MY_SECRET';
        //this.hasBeenUpdated = false;
        //this.layout = new OpenViduLayout();
        //var sessionName = this.props.chat_info.entity_name ? this.props.chat_info.entity_name : 'PechaKucha Chat '+ Math.floor(Math.random() * 100); // should be chat entity_name
        //var sessionId = this.props.chat_info.entity_uuid ? this.props.chat_info.entity_uuid : 'PechaKucha'+ Math.floor(Math.random() * 100); // should be chat entity_uuid
        //var userName = this.props.user_info.nickname ? this.props.user_info.nickname : 'PechaKucha User ' + Math.floor(Math.random() * 100);
        
        //let sessionName = this.props.sessionName ? this.props.sessionName : 'SessionA';
        //let sessionName = this.props.sessionName ? this.props.sessionName : 'SessionA';
        //let userName = this.props.user ? this.props.user : 'OpenVidu_User' + Math.floor(Math.random() * 100);
        this.state = {
          leaving: false,
          host_string: '',
          kicked: false,
          showTransferOwnershipModal: false,
          showConfirmModal: false,
          //mySessionName: sessionName,
          //mySessionId: sessionId,
          //mySessionId: sessionName,
          //myUserName: userName,
          //session: undefined,
          //localUser: undefined,
          //subscribers: [],
          streamList: [], // same as rtc.client.remoteUsers, but has local video unshifted into it plus other data like nickname and volume level
          //chatDisplay: 'none',
          screenShareToggle: false,
          videoActive: true,
          micActive: true
        };
        
        this.subscriber_info_map = {};

        //this.joinSession = this.joinSession.bind(this);
        
        //this.toggleFullscreen = this.toggleFullscreen.bind(this);
        
        
        
        //this.leaveSession = this.leaveSession.bind(this);
        
        //this.onbeforeunload = this.onbeforeunload.bind(this);
        /*
        this.updateLayout = this.updateLayout.bind(this);
        this.camStatusChanged = this.camStatusChanged.bind(this);
        this.micStatusChanged = this.micStatusChanged.bind(this);
        this.nicknameChanged = this.nicknameChanged.bind(this);
        
        this.screenShare = this.screenShare.bind(this);
        this.stopScreenShare = this.stopScreenShare.bind(this);
        this.closeDialogExtension = this.closeDialogExtension.bind(this);
        this.toggleChat = this.toggleChat.bind(this);
        this.checkNotification = this.checkNotification.bind(this);
        this.checkSize = this.checkSize.bind(this);
        */
        AgoraRTC.setLogLevel(3);
        
        //this.report_volume_level_interval = setInterval(() => this.reportVolumeLevel(),5000);
        
        this.highest_current_volume_level = 0;
        this.highest_current_stream_uid = null;
    }
    
    /*
    reportVolumeLevel = () => {
      console.log("reportVolumeLevel");
      this.state.streamList.forEach((item,i) => {
        if (item.hasAudio && item.audioTrack) {
          console.log( "uid volume",item.uid,item.audioTrack.getVolumeLevel());
          item.volume_level = item.audioTrack.getVolumeLevel();
          if (item.volume_level > this.highest_current_volume_level) {
            this.highest_current_volume_level = item.volume_level;
            if (this.highest_current_stream_uid !== item.uid) {
              this.highest_current_stream_uid = item.uid;
              this.assembleSubscribers();
            }
          }
        } else {
          item.volume_level = 0;
        }
      });
    }
    */

    async componentDidUpdate (prevProps, prevState) {
      if (this.props.chat_info.shared_access_write_uuids && prevProps.chat_info.shared_access_write_uuids[0] !== this.props.chat_info.shared_access_write_uuids[0]) {
        // owner changed - call assembleSubscribers
        console.log("CHAT owner changed!");
        this.assembleSubscribers();
      }
      /*
      if (!prevState.kicked && this.state.kicked) {
        // channel ended for some reason
        if (rtc.localAudioTrack) {
          rtc.localAudioTrack.close();
        }
        if (rtc.localVideoTrack) {
          rtc.localVideoTrack.close();
        }
        if (rtc_shareScreen.localVideoTrack) {
          rtc_shareScreen.localVideoTrack.close();
        }
        //alert('This Chat Has Ended - Click OK to Close');
        //this.leaveSession();
      }
      */
    }

    componentDidMount() {
      /*
        const openViduLayoutOptions = {
            maxRatio: 3 / 2, // The narrowest ratio that will be used (default 2x3)
            minRatio: 9 / 16, // The widest ratio that will be used (default 16x9)
            fixedRatio: false, // If this is true then the aspect ratio of the video is maintained and minRatio and maxRatio are ignored (default false)
            bigClass: 'OV_big', // The class to add to elements that should be sized bigger
            bigPercentage: 0.8, // The maximum percentage of space the big ones should take up
            bigFixedRatio: false, // fixedRatio for the big ones
            bigMaxRatio: 3 / 2, // The narrowest ratio to use for the big elements (default 2x3)
            bigMinRatio: 9 / 16, // The widest ratio to use for the big elements (default 16x9)
            bigFirst: true, // Whether to place the big one in the top left (true) or bottom right
            animate: true, // Whether you want to animate the transitions
        };

        this.layout.initLayoutContainer(document.getElementById('layout'), openViduLayoutOptions);
        */
        
        window.addEventListener('beforeunload', this.onbeforeunload);
        //window.addEventListener('unload', this.leaveSession);
        /*
        window.addEventListener('resize', this.updateLayout);
        window.addEventListener('resize', this.checkSize);
        */
        this.joinSession();
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.onbeforeunload);
        //window.removeEventListener('unload', this.leaveSession);
        
        //window.removeEventListener('resize', this.updateLayout);
        //window.removeEventListener('resize', this.checkSize);
        
        //this.leaveSession();
    }
    
    onbeforeunload = async (event) => {
      //event.preventDefault();
      //alert("HEY");
      
      //let message = 'Are you sure you want to close?';
      //event.returnValue = message;
      
      //return message;
      //this.leaveSession(this.props.is_owner);
      
      // JBB 6/10/2021 - note that we don't pass is_owner or close_chat flag because this triggers on reload as well as close
      this.leaveSession();
    }

    joinSession = async () => {
      try {
        
        // default chat type 'video_chat'
        let agora_rtc_client_config = {
          mode: "rtc",
          codec: "vp8"
        };
        
        if (this.props.chat_info.chat_type === 'webinar' || this.props.chat_info.chat_type === 'open_discussion') {
          agora_rtc_client_config = {
            mode: "live",
            codec: "vp8",
            role: this.props.is_owner ? "host" : "audience"
          };
        }
        
        rtc.client = AgoraRTC.createClient(agora_rtc_client_config);
        rtc.client.enableAudioVolumeIndicator();
  
        rtc.client.on("connection-state-change", async (curState,prevState,reason) => {
          console.log("connection-state-change",curState,prevState,reason);
          if (curState === 'DISCONNECTED' && reason.endsWith('_BANNED')) {
            // either the channel was closed by the chat creator, or you were kicked as an individual. Agora seems to send "UID_BANNED" as the reason no matter what.
            // handle in componentDidUpdate so we can immediately stop showing the user's video
            this.setState({ kicked: true });
            if (this.props.onKicked) {
              this.props.onKicked();
            }
            if (rtc.localAudioTrack) {
              rtc.localAudioTrack.close();
            }
            if (rtc.localVideoTrack) {
              rtc.localVideoTrack.close();
            }
            if (rtc_shareScreen.localVideoTrack) {
              rtc_shareScreen.localVideoTrack.close();
            }
            
          }
        });
        
        rtc.client.on("volume-indicator", volumes => {
          let trigger_assembleSubscribers = false;
          let tmp_highest_current_volume_level = 0;
          volumes.forEach((volume, index) => {
            //console.log(`${index} UID ${volume.uid} Level ${volume.level}`);
            
            if (!this.subscriber_info_map[volume.uid]) {
              this.subscriber_info_map[volume.uid] = {};
            }
            this.subscriber_info_map[volume.uid].volume_level = volume.level;
            
            if (volume.level > this.highest_current_volume_level) {
              tmp_highest_current_volume_level = volume.level;
              if (this.highest_current_stream_uid !== volume.uid) {
                //console.log("TRIGGERING VOLUME THING",volume.level,this.highest_current_volume_level,this.highest_current_stream_uid,volume.uid);
                this.highest_current_stream_uid = volume.uid;
                trigger_assembleSubscribers = true;
              }
            }
  
          });
          
          this.highest_current_volume_level = tmp_highest_current_volume_level;
          
          if (trigger_assembleSubscribers) {
            console.log("volume-indicator",trigger_assembleSubscribers);
            this.assembleSubscribers();
          }
  
        })
        
        rtc.client.on("user-published", async (user, mediaType) => {
          // a user has joined the agora rtc channel as a publisher
          console.log("user-published",user,mediaType);
          
          if (user.uid.startsWith(this.props.user_info.entity_uuid)) {
            // this is our local user...ignore it
            console.log("user-published found local stream - ignore");
            return;
          }
          
          // Subscribe to a remote user so we can see/hear them
          await rtc.client.subscribe(user,mediaType);
          
          await this.assembleSubscribers();
          
          // we need to get their info from PK API
          //let user_info_response = await axios.get(`${apiUrl}users/${user.uid}`);
          //let nickname = assembleNickname(user_info_response.data);
          
          //console.log(user);
  
          /*
          if (mediaType === "video") {
            // Get `RemoteVideoTrack` in the `user` object.
  
            //rtc.remoteVideoTrack = user.videoTrack;
            
            
            let tmp_subscribers = [...this.state.subscribers];
            tmp_subscribers.push({...user,nickname});
            this.setState({
              subscribers: tmp_subscribers
            },
              () => {
                //rtc.remoteVideoTrack.play("remote-stream-"+user.uid);
                user.videoTrack.play("remote-stream-"+user.uid);
              }
            );
            
            
  
          }
  
          if (mediaType === "audio") {
            // Get `RemoteAudioTrack` in the `user` object.
            
            //rtc.remoteAudioTrack = user.audioTrack;
            
            //rtc.remoteAudioTrack.play();
            
            
            user.audioTrack.play();
            
  
          }
          */
        });
  
        
        rtc.client.on("user-joined", async (user) => {
          // for webinar, this will mean an audience member was promoted to a speaker (agora host)
          console.log("user-joined",user);
          
          if (user.uid.startsWith(this.props.user_info.entity_uuid)) {
            // this is our local user...ignore it
            console.log("user-joined found local user- ignore");
            return;
          }
  
          await this.assembleSubscribers();
        });
        
  
        rtc.client.on("user-left", async (user, reason) => {
          // when an agora host leaves, or an agora host gets demoted to audience
          console.log("user-left",user,reason);
          await this.assembleSubscribers();
        });
  
        rtc.client.on("user-unpublished", async (user, mediaType) => {
          // someone turns their mic or camera off
          console.log("user-unpublished",user,mediaType);
          
          await this.assembleSubscribers();
          
          // to beat race conditions, just re-assemble from rtc.client.remoteUsers
          
          /*
          if (mediaType === 'video') {
            let tmp_subscribers = [...this.state.subscribers];
            tmp_subscribers = tmp_subscribers.filter( element => element.uid !== user.uid);
            this.setState({
              subscribers: tmp_subscribers
            },
              () => {
                //rtc.remoteVideoTrack.play("remote-stream-"+user.uid);
                this.state.subscribers.forEach((subscriber) => {
                  subscriber.videoTrack.play("remote-stream-"+subscriber.uid);
                })
              }
            );
          }
          */
          
          
          // Get the dynamically created DIV container
          //const playerContainer = document.getElementById(user.uid);
          //console.log(playerContainer);
          // Destroy the container
          //playerContainer.remove();
        });
        
        
        console.log("Agora VideoRoomComponent joinSession",this.AGORA_APP_ID,this.props.init_chat_info.entity_uuid,this.props.token,this.props.user_info.entity_uuid);
        
        const uid = await rtc.client.join(
          this.AGORA_APP_ID,
          this.props.init_chat_info.entity_uuid, // agora channel name - will be chat entity_uuid
          this.props.token,
          //'0060c801d6b0d55406582213b48e5468038IADZmXvZBo+9mvcb0Uwz+c0sPeMKAS+f5DxaZIZVgFamFyjGrYwAAAAAEAAEa9nrHdtHYAEAAQAc20dg',
          //'0060c801d6b0d55406582213b48e5468038IACi2AAgX2LfuujDHloSFFEqHT05fs4Rr9cQKwrjQcYaFyjGrYy/sgIqIgDvPiNap9xHYAQAAQA3mUZgAgA3mUZgAwA3mUZgBAA3mUZg',
          //null
          this.props.user_info.entity_uuid
        );
        
        let publish_flag = false;
        
        if (this.props.chat_info.chat_type === 'webinar' || this.props.chat_info.chat_type === 'open_discussion') {
          if (this.props.is_owner) {
            publish_flag = true;
          }
        } else {
          // video chat or party chat
          publish_flag = true;
        }
        
        if (publish_flag) {
          // Create an audio track from the audio captured by a microphone
          rtc.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack();
          // Create a video track from the video captured by a camera
          rtc.localVideoTrack = await AgoraRTC.createCameraVideoTrack();
    
          //rtc.localVideoTrack.play("local-stream");
    
          // Publish the local audio and video tracks to the channel
          await rtc.client.publish([rtc.localAudioTrack, rtc.localVideoTrack]);
        }
        
        //localUser.setAudioActive(true);
        //localUser.setVideoActive(true);
        //this.setState({ localUser: localUser });
        
        /*
        if (rtc.localVideoTrack) {
          this.setState({ localVideoTrack: rtc.localVideoTrack });
        }
        */
  
        await this.assembleSubscribers();
  
        if (this.props.joinSession) {
          // record join in database via API
          this.props.joinSession();
        }      
      
      } catch (error) {
        console.error("SOME AGORA ERROR",error);
      }      
      

    }

  shareScreen = async () => {
    let toggle = !this.state.screenShareToggle;
    let ss_uid = this.props.user_info.entity_uuid+'_screenshare';
    console.log('shareScreen',toggle,ss_uid);
    
    if (toggle) {
      try { 
      
        rtc_shareScreen.client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
        //rtc_shareScreen.client.setLogLevel(3);
        await rtc_shareScreen.client.join(
          this.AGORA_APP_ID,
          this.props.init_chat_info.entity_uuid, // agora channel name - will be chat entity_uuid
          this.props.ss_token,
          //'0060c801d6b0d55406582213b48e5468038IADZmXvZBo+9mvcb0Uwz+c0sPeMKAS+f5DxaZIZVgFamFyjGrYwAAAAAEAAEa9nrHdtHYAEAAQAc20dg',
          //'0060c801d6b0d55406582213b48e5468038IACi2AAgX2LfuujDHloSFFEqHT05fs4Rr9cQKwrjQcYaFyjGrYy/sgIqIgDvPiNap9xHYAQAAQA3mUZgAgA3mUZgAwA3mUZgBAA3mUZg',
          //null
          ss_uid
        );

        rtc_shareScreen.localVideoTrack = await AgoraRTC.createScreenVideoTrack();

        rtc_shareScreen.localVideoTrack.on('track-ended', () => {
          console.log('SCREENSHARE ENDED BY BROWSER');
          if (rtc_shareScreen.localVideoTrack) {
            rtc_shareScreen.localVideoTrack.close();
            //await rtc_shareScreen.client.unpublish([rtc_shareScreen.localVideoTrack]);
            rtc_shareScreen.client.leave();
            rtc_shareScreen.localVideoTrack = null;
            rtc_shareScreen.client = null;
          }
          this.setState({ screenShareToggle: false });
        });
        
        
        await rtc_shareScreen.client.publish([rtc_shareScreen.localVideoTrack]);
        this.setState({ screenShareToggle: true });
      } catch (err) {
        console.error(" AgoraRTC.createScreenVideoTrack ERR",err);
        if (rtc_shareScreen.localVideoTrack) {
          rtc_shareScreen.localVideoTrack.close();
          rtc_shareScreen.localVideoTrack = null;
        }
        if (rtc_shareScreen.client) {
          rtc_shareScreen.client.leave();
          rtc_shareScreen.client = null;
        }
        this.setState({ screenShareToggle: false });
      }
      
    } else {
      if (rtc_shareScreen.localVideoTrack) {
        rtc_shareScreen.localVideoTrack.close();
        //await rtc_shareScreen.client.unpublish([rtc_shareScreen.localVideoTrack]);
        rtc_shareScreen.client.leave();
        rtc_shareScreen.localVideoTrack = null;
        rtc_shareScreen.client = null;
      }
      this.setState({ screenShareToggle: false });
    }
    
    await this.assembleSubscribers();
  }

    
  assembleSubscribers = async () => {
    
    console.log("assembleSubscribers",typeof rtc.localVideoTrack,typeof rtc_shareScreen.localVideoTrack);
    let tmp_subscribers = [...rtc.client.remoteUsers];
    let tmp_host_string = '';
    
    // filter out our own screenshare
    tmp_subscribers = tmp_subscribers.filter( (item) => !item.uid.startsWith(this.props.user_info.entity_uuid));
    
    // assign priority based on volume
    tmp_subscribers.forEach((user,i) => {
      if (this.subscriber_info_map[user.uid] && this.subscriber_info_map[user.uid].volume_level) {
        user.priority = this.subscriber_info_map[user.uid].volume_level; // volume_level should go from 0 to 100
      } else {
        user.priority = 0;
      }
    });
    
    // get nicknames if we don't have them
    let user_info_promises = [];
    let user_info_promises_subscriber_index = [];
    tmp_subscribers.forEach((user,i) => {
      let real_user_uuid = user.uid;
      if (user.uid.endsWith('_screenshare')) {
        real_user_uuid = user.uid.substring(0,user.uid.length-12);
        user.priority = 101 + i; // assign most recent screenshare highest priority
        user.owner = false;
      } else {
        // is this user the chat owner?
        if (this.props.init_chat_info.shared_access_write_uuids.includes(real_user_uuid)) {
          // owner!
          user.owner = true;
        } else {
          user.owner = false;
        }
      }
      
      if (!this.subscriber_info_map[real_user_uuid]) {
        console.log("assembleSubscribers getting user_info",real_user_uuid);
        user_info_promises.push(axios.get(`${apiUrl}users/${real_user_uuid}`));
        user_info_promises_subscriber_index.push(i);
      } else {
        if (user.uid.endsWith('_screenshare')) {
          user.nickname = assembleNickname(this.subscriber_info_map[real_user_uuid])+' (Screen)';
        } else {
          user.nickname = assembleNickname(this.subscriber_info_map[real_user_uuid]);
        }
        if (user.owner) {
          tmp_host_string = user.nickname;
        }
      }
    });
    let user_info_responses = await Promise.all(user_info_promises);
    user_info_responses.forEach((user_info_response,i) => {
      this.subscriber_info_map[user_info_response.data.entity_uuid] = user_info_response.data;
      //let nickname = assembleNickname(user_info_response.data);
      if (tmp_subscribers[user_info_promises_subscriber_index[i]].uid.endsWith('_screenshare')) {
        tmp_subscribers[user_info_promises_subscriber_index[i]].nickname = assembleNickname(user_info_response.data)+' (Screen)';
      } else {
        tmp_subscribers[user_info_promises_subscriber_index[i]].nickname = assembleNickname(user_info_response.data);
      }
      if (tmp_subscribers[user_info_promises_subscriber_index[i]].owner) {
        tmp_host_string = tmp_subscribers[user_info_promises_subscriber_index[i]].nickname;
      }
    });
    
    // now order by priority
    tmp_subscribers = tmp_subscribers.sort((a, b) => (a.priority > b.priority) ? 1 : -1);
    console.log(" sorted by priority",tmp_subscribers);
    
    let tmp_streamList = [...tmp_subscribers];
    //console.log(" WTF1");
    if (rtc_shareScreen.localVideoTrack) {
      //console.log(" WTF2");
      let tmp_stream_obj = {
        uid: this.props.user_info.entity_uuid+'_screenshare',
        nickname: this.props.user_info.nickname+' (Screen)',
        hasVideo: true,
        videoTrack: rtc_shareScreen.localVideoTrack
      };
      tmp_streamList.unshift(tmp_stream_obj);
    }
    if (rtc.localVideoTrack) {
      //console.log(" WTF2");
      // is this user the chat owner?
      let tmp_owner = false;
      if (this.props.init_chat_info.shared_access_write_uuids.includes(this.props.user_info.entity_uuid)) {
        // owner!
        tmp_owner = true;
        tmp_host_string = this.props.user_info.nickname+' (You)';
      }

      let tmp_stream_obj = {
        uid: this.props.user_info.entity_uuid,
        owner: tmp_owner,
        nickname: this.props.user_info.nickname+' (You)',
        hasVideo: true,
        videoTrack: rtc.localVideoTrack
      };
      tmp_streamList.unshift(tmp_stream_obj);
    }
    console.log(" tmp_streamList",tmp_streamList);

    // make it happen on screen
    this.setState({
      //subscribers: tmp_subscribers,
      streamList: tmp_streamList,
      host_string: tmp_host_string
    },
      () => {
        /*
        this.state.subscribers.forEach((subscriber) => {
          if (subscriber.hasVideo && subscriber.videoTrack) {
            subscriber.videoTrack.play("remote-stream-"+subscriber.uid);
          }
          if (subscriber.hasAudio && subscriber.audioTrack) {
            subscriber.audioTrack.play();
          }
        })
        */
      }
    );
  }
    
  leaveSession = async (close_chat_flag = false) => {
    console.log("VideoRoomComponent leaveSession",close_chat_flag);
    this.setState({ leaving: true });
    //alert('wtf2');
    try {
      //const localContainer = document.getElementById("local-stream");

      if (rtc.localAudioTrack) {
        rtc.localAudioTrack.close();
      }
      if (rtc.localVideoTrack) {
        rtc.localVideoTrack.close();
      }
      if (rtc_shareScreen.localVideoTrack) {
        rtc_shareScreen.localVideoTrack.close();
      }

      //setJoined(false);
      
      //localContainer.textContent = "";

      // Traverse all remote users
      
      //rtc.client.remoteUsers.forEach((user) => {
        // Destroy the dynamically created DIV container
        //const playerContainer = document.getElementById('remote-stream-'+user.uid);
        //playerContainer && playerContainer.remove();
      //});

      // Leave the channel
      //await rtc.client.leave();
      if (rtc.client) {
        rtc.client.leave();
      }
      
      if (rtc_shareScreen.client) {
        rtc_shareScreen.client.leave();
      }
      
      if (this.props.leaveSession) {
        this.props.leaveSession(close_chat_flag);
      }
      
    } catch (err) {
      console.error(err);
    }
  }
  
    micStatusChanged = async () => {
      console.log("micStatusChanged",this.state.micActive,rtc.localAudioTrack);
      
      
      /*
      localUser.getStreamManager().publishAudio(localUser.isAudioActive());
      this.sendSignalUserChanged({ isAudioActive: localUser.isAudioActive() });
      this.setState({ localUser: localUser });
      */
      
      await rtc.localAudioTrack.setEnabled(!this.state.micActive);
      
      this.setState({ micActive: !this.state.micActive });
      
      
      //localUser.setAudioActive(!localUser.isAudioActive());
      //this.setState({ localUser: localUser });
      
      
      /*
      if (rtc.localAudioTrack) {
        await rtc.localAudioTrack.setEnabled(false);
      } else {
        await rtc.localAudioTrack.setEnabled(true);
      }
      */
    }
    
    camStatusChanged = async () => {
      console.log("camStatusChanged",this.state.videoActive,rtc.localVideoTrack);

      await rtc.localVideoTrack.setEnabled(!this.state.videoActive);
      
      this.setState({ videoActive: !this.state.videoActive });
      
      
      //localUser.setVideoActive(!localUser.isVideoActive());
      //this.setState({ localUser: localUser });
      
      //localUser.getStreamManager().publishVideo(localUser.isVideoActive());
      //this.sendSignalUserChanged({ isVideoActive: localUser.isVideoActive() });

      
    }



    hideConfirmModal = () => {
      this.setState({
        showConfirmModal: false
      });
      //setShowConfirmModal(false);
    }




    render() {
      /*
        const mySessionId = this.state.mySessionId;
        const localUser = this.state.localUser;
        var chatDisplay = { display: this.state.chatDisplay };
        
        const xs_cols = 12;
        const md_cols = this.state.subscribers.length >= 1 ? 6 : 12;
        const xl_cols = this.state.subscribers.length >= 2 ? 4 : this.state.subscribers.length >= 1 ? 6 : 12;
        
        const agora_stream_div_class_number = this.state.subscribers.length >= 3 ? 4 : this.state.subscribers.length+1;
        */
        
        return (
   <div className="wrapper meeting">
        <div className="ag-header">
          <div className="ag-header-lead">
            <img
              className="header-logo"
              src={logo}
              alt=""
            />
            {/*<span>PechaKucha Chats</span>*/}
          </div>
          <div className="ag-header-msg">
            { this.state.host_string &&
              <React.Fragment>Host:&nbsp;<span id="host-name" style={{ marginRight: "15px", fontWeight: "bolder" }}>{this.state.host_string}</span></React.Fragment>
            }
            Chat:&nbsp;<span id="room-name" style={{ marginRight: "15px", fontWeight: "bolder" }}>{this.props.init_chat_info.entity_name || ''}</span>
            { (this.props.is_owner && this.props.chat_info.entity_uuid) &&
              <i onClick={() => this.setState({ showTransferOwnershipModal: true })} className="fa fa-cog" aria-hidden="true" style={{ fontSize: "larger" }}></i>
            }
          </div>
        </div>
        <div className="ag-main">
          <div className="ag-container">
              { this.state.leaving &&
                <React.Fragment>
                  <Alert show={true} variant="warning">
                    <Alert.Heading>Leaving Chat</Alert.Heading>
                    <hr />
                    <div className="d-flex justify-content-end">
                      <Button onClick={() => this.leaveSession()} variant="outline-success">
                        Close
                      </Button>
                    </div>
                  </Alert>
                </React.Fragment>
              }
              { (!this.state.leaving && this.state.kicked) ?
                <React.Fragment>
                  <Alert show={true} variant="warning">
                    <Alert.Heading>This Chat has ended, or you have been removed by the host</Alert.Heading>
                    <p>
                      Please Close This Window
                    </p>
                    <hr />
                    <div className="d-flex justify-content-end">
                      <Button onClick={() => this.leaveSession()} variant="outline-success">
                        Close
                      </Button>
                    </div>
                  </Alert>
                </React.Fragment>
                :
                <AgoraVideoCall
                  streamList={this.state.streamList}
                  //localVideoTrack={this.state.localVideoTrack}
                  //videoProfile={this.videoProfile}
                  //channel={this.channel}
                  //transcode={this.transcode}
                  attendeeMode={this.attendeeMode || 'video'}
                  //baseMode={this.baseMode}
                  //appId={this.appId}
                  //uid={this.uid}
                  camStatusChanged={this.camStatusChanged}
                  micStatusChanged={this.micStatusChanged}
                  //leaveSession={this.leaveSession}
                  leaveSession={this.props.is_owner ? () => this.setState({ showConfirmModal: true }) : this.leaveSession}
                  shareScreen={this.shareScreen}
                  screenShareToggle={this.state.screenShareToggle}
                />
              }
        </div>
        </div>
        <div className="ag-footer">
          <a className="ag-href" href="https://www.pechakucha.com">
            <span>Powered By PechaKucha</span>
          </a>
          <span>Need support? Email support@pechakucha.org</span>
        </div>

        { this.props.chat_info.entity_uuid &&
          <TextChat
            user_info={this.props.user_info}
            chat_info={this.props.chat_info}
            theme={this.props.theme}
            rtm_token={this.props.rtm_token}
          />
        }
        
        <ConfirmLeaveChatModal
          //is_owner={this.props.is_owner}
          streamList={this.state.streamList}
          show={this.state.showConfirmModal}
          onLeave={() => this.leaveSession(true)}
          onHide={() => this.setState({ showConfirmModal: false })}
          transferOwnership={() => this.setState({ showTransferOwnershipModal: true })}
        />

        { this.props.chat_info.entity_uuid &&
          <ChangeChatHostModal
            //is_owner={this.props.is_owner}
            chat_info={this.props.chat_info}
            streamList={this.state.streamList}
            show={this.state.showTransferOwnershipModal}
            //onLeave={() => this.leaveSession(true)}
            //onHide={() => this.hideConfirmModal()}
            onHide={() => this.setState({ showTransferOwnershipModal: false })}
            onTransferOwnership={(stream_obj) => this.props.transferOwnership(stream_obj)}
            onKickUser={(stream_obj) => this.props.kickUser(stream_obj)}
            onInviteUser={(user_info) => this.props.onInviteUser(user_info)}
            //transferOwnership={() => this.setState({ showTransferOwnershipModal: true })}
          />
        }
        
        {/*
        <div>
            <Modal size="sm" show={this.state.showConfirmModal} onHide={() => this.hideConfirmModal()} className="modal-contact-custom" >
                <div>
                    <ConfirmModal
                        modalText={`Are you SURE?!?`}
                        OnConfirmDelete={() => this.leaveSession()}
                        hideConfirmModal={() => this.hideConfirmModal()}
                    />
                    <div>
                        <Button theme="contact-button" onClick={() => this.hideConfirmModal()}>
                            x
                        </Button>
                    </div>
                 </div>
            </Modal>
        </div>
        */}     
          
          
          
          
            {/*
            <Container fluid={true} id="container">
            
            
                <ToolbarComponent
                    sessionName={this.state.mySessionName}
                    sessionId={mySessionId}
                    user={localUser}
                    showNotification={this.state.messageReceived}
                    camStatusChanged={this.camStatusChanged}
                    micStatusChanged={this.micStatusChanged}
                    screenShare={this.screenShare}
                    stopScreenShare={this.stopScreenShare}
                    toggleFullscreen={this.toggleFullscreen}
                    leaveSession={this.leaveSession}
                    toggleChat={this.toggleChat}
                />
                
                
                <Container fluid={true} style={{ marginTop: "50px" }}>
                  <Row noGutters={true} className="justify-content-center">
                    <Col xs={xs_cols} md={md_cols} xl={xl_cols} style={{ padding: "1px" }}>
                      <center>
                        <h3>{this.props.user_info.nickname}</h3>
                        <div id="local-stream" className={`agora-stream-div-${this.state.subscribers.length+1}`}></div>
                      </center>
                    </Col>
                  
                    {this.state.subscribers.map((sub, i) => (
                      <Col key={sub.uid} xs={xs_cols} md={md_cols} xl={xl_cols} style={{ padding: "1px" }}>
                        <center>
                          <h3>{sub.nickname} {sub.hasAudio ? <Mic /> : <MicOff color="secondary" />}</h3>
                          <div id={"remote-stream-"+sub.uid} style={{ backgroundColor: 'black' }} className={`agora-stream-div-${this.state.subscribers.length+1}`}></div>
                        </center>
                      </Col>
                    ))}
                  </Row>
                </Container>
              </Container>  
              */}


                
            
                {/*
                <DialogExtensionComponent showDialog={this.state.showExtensionDialog} cancelClicked={this.closeDialogExtension} />
                */}
                
                {/*
                <div id="layout" className="bounds">
                    {localUser !== undefined && localUser.getStreamManager() !== undefined && (
                        <div className="OT_root OT_publisher custom-class" id="localUser">
                            <StreamComponent user={localUser} handleNickname={this.nicknameChanged} />
                        </div>
                    )}
                    {this.state.subscribers.map((sub, i) => (
                        <div key={i} className="OT_root OT_publisher custom-class" id="remoteUsers">
                            <StreamComponent user={sub} streamId={sub.streamManager.stream.streamId} />
                        </div>
                    ))}
                    
                    
                    {localUser !== undefined && localUser.getStreamManager() !== undefined && (
                        <div className="OT_root OT_publisher custom-class" style={chatDisplay}>
                            <ChatComponent
                                sessionName={this.state.mySessionName}
                                user={localUser}
                                chatDisplay={this.state.chatDisplay}
                                close={this.toggleChat}
                                messageReceived={this.checkNotification}
                            />
                        </div>
                    )}
                    
                </div>
                */}
            
            {/*</div>*/}
            </div>
        );
    }

    /**
     * --------------------------
     * SERVER-SIDE RESPONSIBILITY
     * --------------------------
     * These methods retrieve the mandatory user token from OpenVidu Server.
     * This behaviour MUST BE IN YOUR SERVER-SIDE IN PRODUCTION (by using
     * the API REST, openvidu-java-client or openvidu-node-client):
     *   1) Initialize a session in OpenVidu Server	(POST /api/sessions)
     *   2) Generate a token in OpenVidu Server		(POST /api/tokens)
     *   3) The token must be consumed in Session.connect() method
     */

    /*
    getToken() {
        return this.createSession(this.state.mySessionId).then((sessionId) => this.createToken(sessionId));
    }

    createSession(sessionId) {
        return new Promise((resolve, reject) => {
            var data = JSON.stringify({ customSessionId: sessionId });
            axios
                .post(this.OPENVIDU_SERVER_URL + '/api/sessions', data, {
                    headers: {
                        Authorization: 'Basic ' + btoa('OPENVIDUAPP:' + this.OPENVIDU_SERVER_SECRET),
                        'Content-Type': 'application/json',
                    },
                })
                .then((response) => {
                    console.log('CREATE SESION', response);
                    resolve(response.data.id);
                })
                .catch((response) => {
                    var error = Object.assign({}, response);
                    if (error.response && error.response.status === 409) {
                        resolve(sessionId);
                    } else {
                        console.log(error);
                        console.warn(
                            'No connection to OpenVidu Server. This may be a certificate error at ' + this.OPENVIDU_SERVER_URL,
                        );
                        if (
                            window.confirm(
                                'No connection to OpenVidu Server. This may be a certificate error at "' +
                                    this.OPENVIDU_SERVER_URL +
                                    '"\n\nClick OK to navigate and accept it. ' +
                                    'If no certificate warning is shown, then check that your OpenVidu Server is up and running at "' +
                                    this.OPENVIDU_SERVER_URL +
                                    '"',
                            )
                        ) {
                            window.location.assign(this.OPENVIDU_SERVER_URL + '/accept-certificate');
                        }
                    }
                });
        });
    }

    createToken(sessionId) {
        return new Promise((resolve, reject) => {
            var data = JSON.stringify({ session: sessionId });
            axios
                .post(this.OPENVIDU_SERVER_URL + '/api/tokens', data, {
                    headers: {
                        Authorization: 'Basic ' + btoa('OPENVIDUAPP:' + this.OPENVIDU_SERVER_SECRET),
                        'Content-Type': 'application/json',
                    },
                })
                .then((response) => {
                    console.log('TOKEN', response);
                    resolve(response.data.token);
                })
                .catch((error) => reject(error));
        });
    }
    */
}
export default VideoRoomComponent;
